export default __webpack_public_path__ + "static/media/G-ROCKET_white.85466fb1.jpg";